import React from "react";
import { images } from "../../data/images";
import { OFFER_HASH } from "../../data/links";
type MockupLinkProps = {
  className?: string;
};
export function MockupLink({
  className = ""
}: MockupLinkProps) {
  return <a href={OFFER_HASH} className={`block rounded-xl focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-navy/30 ${className}`} data-id="element-175" data-mp="3igcc1bai5qn9">
      <img src={images.mockup} alt="Prenatal Training Pro 2026 complete system: 5 professional volumes and 5 professional bonuses" className="h-auto w-full drop-shadow-[0_14px_20px_rgba(28,47,79,0.2)]" data-id="element-176" data-mp="3dmrbpclfskkw" />
    </a>;
}